import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import EventsBanner from './events-banner'; 
import EventsLists from './events-lists'; 

function EventsPage () {
    return(
      <Fragment> 
      <Header />  
      <EventsBanner />  
      <EventsLists />  
      <Footer /> 
      </Fragment> 
    );
}
export default EventsPage;